'use strict';

var AppState = require('app_state');
var Consts = require('consts');
var Decorator = require('utils/decoration');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var Notification = require('utils/notification');
var utils = require('components/common/utils');

require('utils/charts/dygraph-trovis');
require('utils/charts/dygraph-trovis-interaction');
require('utils/charts/dygraph-trovis-annotation');
require('utils/charts/dygraph-trovis-range-selector');
require('utils/charts/dygraph-legend');
require('utils/charts/dygraph-synchronizer');
require('utils/charts/dygraph-extra');

function getSeriesIntervalMS(timeWindow, xpos) {
    var timeWindowInfo = Misc.selectWhereFirst(Consts.ChartTimeWindows(), function (item) {
        return item.id == timeWindow;
    });
    if (timeWindowInfo.actual == 'month') {
        return moment(xpos).add(1, 'M').valueOf() - xpos;
    }
    return timeWindowInfo.mins * 60000;
}

function getSeriesIntervalPx(dygraph, timeWindow, xpos) {
    var timeLength = getSeriesIntervalMS(timeWindow, xpos);
    return dygraph.toDomXCoord(xpos + timeLength, 0) - dygraph.toDomXCoord(xpos, 0);
}

var ChartView = Marionette.ItemView.extend({
    binaryValueRange: [0, 1.2],
    data: undefined,
    defaultBinHeight: 100,
    labelPadding: 2,
    labelMinWidth: 65,
    minTotalHeight: 380,
    minExportHeight: 200,
    minExportWidth: 1024,
    classBinary: 'chart-bin',
    classLinear: 'chart-linear',
    expectedMarginBottom: 50,
    showEvents: true,
    selectedAxis: {},
    chartAxes: {},
    chartAxesSettings: {},
    lastChartID: undefined,

    ui: {
        footer: '.footer',
    },
    template: require('components/devices/templates/common/charts'),
    initialize: function (options) {
        this.data = options.data;
        this.currentDeviceCategory = options.currentDeviceCategory;
        this.annotationTypes.device_status.currentDeviceCategory = this.currentDeviceCategory;
    },

    redraw: function () {
        var currentDateWindow = this.getDateWindow();
        this.updateOptions(currentDateWindow[0], currentDateWindow[1], true, true);
    },

    annotationTypes: {
        device_ok: {
            text: function (a) {
                return i18n.TR('Betriebsbereit');
            },
            type: 'ok',
        },
        device_seen: {
            text: function (a) {
                return i18n.TR('Letzter Kontakt');
            },
            type: 'ok',
        },
        alarm_trigger: {
            text: function (a) {
                return Handlebars.escapeExpression(a.name);
            },
            type: 'alarm',
        },
        device_status: {
            text: function (a) {
                return _.map(
                    Misc.getErrorsFromStatus(a.ref_id, this.currentDeviceCategory, a.custom_data),
                    function (a) {
                        return a.text;
                    }
                ).join();
            },
            type: 'warn',
        },
        device_reg: {
            text: function (a) {
                return i18n.TR('Registriert');
            },
            type: 'ok',
        },
        device_replacement: {
            text: function (a) {
                return i18n.TR('Gerätetausch');
            },
            type: 'info',
        },
        device_grant_onsite_access: {
            text: function (a) {
                return i18n.TR('Freigabe für vor-Ort-Konfiguration');
            },
            type: 'info',
        },
        meter_time_sync: {
            text: function (a) {
                return i18n.TR('Zeitsynchronisation');
            },
            type: 'info',
        },
        meter_time_anomaly: {
            text: function (a) {
                return i18n.TR('Zeitabweichung zu groß');
            },
            type: 'warn',
        },
        create_backup: {
            text: function (a) {
                return i18n.TR('Backup erstellt');
            },
            type: 'info',
        },
        restore_backup: {
            text: function (a) {
                return i18n.TR('Backup eingespielt');
            },
            type: 'warn',
        },
        firmware_update: {
            text: function (a) {
                return i18n.TR('Firmware Update');
            },
            type: 'info',
        },
    },

    barChartPlotter: function (e) {
        var serie = e.dygraph.user_attrs_.seriesInfo[e.seriesIndex];
        var ctx = e.drawingContext;
        var points = e.points;
        var baseValue = 0;

        var y_bottom = e.dygraph.toDomYCoord(baseValue, 0);

        function setColour(isMeterChange) {
            var c = e.color;
            var rgba = c.match(/\d+/g);
            rgba.push(isMeterChange ? 0.1 : 0.5);
            rgba = 'rgba(' + rgba + ')';

            ctx.strokeStyle = rgba;
            ctx.fillStyle = rgba;
            ctx.lineWidth = serie.selected ? 2.5 : 1;
        }

        // Find the minimum separation between x-values.
        // This determines the bar width.
        var min_sep = Infinity;

        // extract valid positions
        var positionX = [];
        _.each(points, function (p) {
            if (!isNaN(p.canvasy)) positionX.push(p.canvasx);
        });

        for (var i = 1; i < positionX.length; i++) {
            var sep = positionX[i] - positionX[i - 1];
            if (sep < min_sep) min_sep = sep;
        }

        if (positionX.length <= 1) {
            min_sep = 1;
        }

        var bar_width = Math.floor((2.0 / 3) * min_sep);
        bar_width = Math.min(bar_width, 50);

        e.dygraph.user_attrs_.barWidth = bar_width;

        var meterChangeTime = (e.dygraph.user_attrs_.sourceData.meterChange || [])[e.seriesIndex];

        // Do the actual plotting.
        for (var i = 0; i < points.length; i++) {
            var p = points[i];
            var center_x = p.canvasx;

            var isMeterChange = false;

            _.each(meterChangeTime, function (timeStamp) {
                isMeterChange = isMeterChange || timeStamp == p.xval / 1000;
            });

            setColour(isMeterChange);

            // bar
            ctx.fillRect(center_x - bar_width / 2, p.canvasy, bar_width, y_bottom - p.canvasy);

            ctx.strokeRect(center_x - bar_width / 2, p.canvasy, bar_width, y_bottom - p.canvasy);
        }
    },

    lineAggChartPlotter: function (e) {
        var serie = e.dygraph.user_attrs_.seriesInfo[e.seriesIndex];
        var ctx = e.drawingContext;
        var points = e.points;
        e.dygraph.user_attrs_.lineAggPoints = e.dygraph.user_attrs_.lineAggPoints || {};
        e.dygraph.user_attrs_.lineAggPoints[e.seriesIndex] = {};

        function setColour(isMeterChange) {
            var c = e.color;
            var rgba = c.match(/\d+/g);
            rgba.push(isMeterChange ? 0.1 : 0.5);
            rgba = 'rgba(' + rgba + ')';

            ctx.strokeStyle = rgba;
            ctx.fillStyle = rgba;
            ctx.lineWidth = serie.selected ? 2.5 : 1;
        }

        var meterChangeTime = (e.dygraph.user_attrs_.sourceData.meterChange || [])[e.seriesIndex];

        // Do the actual plotting.
        var lastX = undefined;
        var lastY = undefined;
        ctx.beginPath();
        for (var i = 0; i < points.length; i++) {
            var p = points[i];
            var isMeterChange = false;

            if (isNaN(p.canvasy)) {
                continue;
            }

            _.each(meterChangeTime, function (timeStamp) {
                isMeterChange = isMeterChange || timeStamp == p.xval / 1000;
            });

            setColour(isMeterChange);

            ctx.moveTo(p.canvasx, p.canvasy);
            var xLength = getSeriesIntervalPx(e.dygraph, serie.displaySettings.timeWindow, p.xval);
            ctx.lineTo(p.canvasx + xLength, p.canvasy);

            e.dygraph.user_attrs_.lineAggPoints[e.seriesIndex][p.canvasx] = {
                p: p,
                xLength: xLength,
            };

            lastX = p.canvasx;
            lastY = p.canvasy;
        }
        ctx.stroke();
    },

    lineChartPlotter: function (e) {
        var ctx = e.drawingContext;
        var points = e.points;
        ctx.strokeStyle = e.color;
        ctx.fillStyle = e.color;

        var serie = e.dygraph.user_attrs_.seriesInfo[e.seriesIndex];
        var maxY = 2000000;

        var prevI = undefined;
        var interpolation = {};
        var intKey = Math.pow(2, e.seriesIndex);
        var minInterval = undefined;

        for (var i = 0; i < points.length; i++) {
            var p = points[i];
            var irow = e.dygraph.user_attrs_.interpolatedData[p.idx];
            var isInt = irow & intKey;
            if (!isInt && !isNaN(p.canvasy) && p.canvasy !== null) {
                interpolation[i] = p.canvasx;
                if (prevI) {
                    var interval = interpolation[i] - interpolation[prevI];
                    minInterval = !minInterval ? interval : Math.min(interval, minInterval);
                }
                prevI = i;
            }
        }

        var isPoint = false;
        ctx.lineWidth = serie.selected ? 2.5 : 1;
        ctx.beginPath();
        for (var i = 0; i < points.length; i++) {
            var p = points[i];
            var center_x = p.canvasx;

            if (isNaN(p.canvasy) || p.canvasy === null) {
                isPoint = false;
                continue;
            }

            var fixValue = function (y) {
                return Math.max(Math.min(y, maxY), -maxY);
            };

            if (!isPoint) {
                ctx.moveTo(p.canvasx, fixValue(p.canvasy));
                isPoint = true;
            } else {
                var y = fixValue(p.canvasy);
                ctx.lineTo(p.canvasx, y);
            }
        }
        ctx.stroke();

        ctx.beginPath();
        for (var i = 0; i < points.length; i++) {
            var p = points[i];
            if (interpolation[i] && (minInterval > 7 || minInterval === undefined)) {
                ctx.moveTo(p.canvasx, p.canvasy);
                ctx.arc(p.canvasx, p.canvasy, 2, 0, 2 * Math.PI);
            }
        }
        ctx.stroke();
    },

    buildEventAnnotation: function (a) {
        if (!this.annotationTypes[a.item_type]) return;

        var result = $.extend(false, {}, this.annotationTypes[a.item_type]);
        result.text = result.text(a);
        result.x = new Date(a.event_time).getTime();
        return result;
    },

    displayData: function (from, till, selectedSeries, isReload, keepZoom, onSuccess, onError, showEvents) {
        var self = this;
        this.showEvents = showEvents;
        var displayDataCallback = function (content) {
            self.displayLoadedData(from, till, isReload, keepZoom, onSuccess, onError, true);
        };

        var displayErrorCallback = function (err) {
            self.displayLoadedData(from, till, isReload, keepZoom, onSuccess, onError, false);
        };

        this.data.selectedSeries = selectedSeries;
        if (!isReload) {
            Decorator.displayLoading(true);
        }
        this.data.loadData(from, till, displayDataCallback, displayErrorCallback, true);
    },

    showHide: function (show) {
        function showHideSingle(selector) {
            if (show) {
                $(selector).show();
            } else $(selector).hide();
        }

        showHideSingle('.' + this.classBinary);
        showHideSingle('.' + this.classLinear);
    },

    displayLoadedData: function (from, till, isReload, keepZoom, onSuccess, onError, isSuccess) {
        this.showHide(true);
        isSuccess = isSuccess && !this.data.isEmpty();
        var callFunction = isSuccess ? onSuccess : onError;
        if (callFunction) callFunction();

        if (!isReload) {
            this.resetCharts();
        }

        this.trigger('charts:draw:before');
        if (isSuccess) this.updateOptions(from.getTime(), till.getTime(), false, isReload && keepZoom);
        this.trigger('charts:draw:after');
        Decorator.displayLoading(false);
    },

    resetCharts: function () {
        this.clearCharts();
        this.buildCharts();
        this.updateHeight();
    },

    clearCharts: function () {
        this.chartLineCounts = { bin: 0, linear: 0 };
        this.lastStrip = undefined;
        this.charts = {};
        $(this.el)
            .find('.' + this.classLinear)
            .html('');
        $(this.el)
            .find('.' + this.classBinary)
            .html('');
    },

    buildCharts: function () {
        var self = this;
        var lastStrip = undefined;
        var isAlternate = false;

        // calculates the number of series with float and binary data (coils)
        var getSeriesCounts = function () {
            var result = { bin: 0, linear: 0 };
            for (var i = 0; i < self.data.selectedSeries.length; i++) {
                var key = self.data.selectedSeries[i].isBinary ? 'bin' : 'linear';
                result[key]++;
            }
            return result;
        };

        var getChartName = function (idx, isBin, isSelector) {
            return (isSelector ? '#' : '') + (isBin ? 'binary' : 'linear') + '_chart_' + idx;
        };

        var getStripClass = function (isBinary) {
            return isBinary ? self.classBinary : self.classLinear;
        };

        // synchronizeStrips creates and removes strips (DIVs) acoording to current and required number
        var synchronizeStrips = function (isBinary, cnt) {
            // delete existing
            var key = isBinary ? 'bin' : 'linear';
            while (self.chartLineCounts[key] > cnt) {
                var id = getChartName(i, isBinary, true);
                $(id).remove();
                this.chartLineCounts[key]--;
            }

            // create new
            while (self.chartLineCounts[key] < cnt) {
                var divClass = getStripClass(isBinary);
                var css = isAlternate && isBinary ? 'class="chart-bin-alternate"' : '';
                var html =
                    '<div id="' + getChartName(self.chartLineCounts[key], isBinary, false) + '" ' + css + '></div>';
                if (isBinary) isAlternate = !isAlternate;

                $('.' + divClass).append(html);
                self.chartLineCounts[key]++;
            }
        };

        // synchronizeChartObjects creates DyGraph objects for given series
        var synchronizeChartObjects = function () {
            var oldNames = [];
            for (var key in self.charts) oldNames.push(key);

            // does every chart have a corresponding div? if not, delete
            for (var i = 0; i < oldNames.length; i++) {
                var name = oldNames[i];
                if ($('#' + name).length == 0) delete self.charts[name];
            }

            // create new binary charts
            var createNewCharts = function (isBinary, destList) {
                for (var i = 0; i < destList.length; i++) {
                    var div = destList[i];
                    var id = div.id;

                    if (self.charts[id] == undefined) {
                        Decorator.displayLoading(true);
                        self.charts[id] = new Dygraph(
                            div,
                            [
                                [0, 0],
                                [1, 0],
                            ],
                            {
                                showRangeSelector: self.lastStrip == id,
                                interactionModel: Dygraph.Interaction.defaultModel,
                                labels: ['', ''],
                                rangeSelectorHeight: 30,
                                sourceData: self.data,
                            }
                        );
                    }
                }
            };

            createNewCharts(true, $('.' + self.classBinary).children('div'));
            createNewCharts(false, $('.' + self.classLinear).children('div'));
        };

        var clearChartObjects = function () {
            self.charts = {};
            $(self.classBinary).children().html('');
            $(self.classLinear).children().html('');
        };

        var counts = getSeriesCounts();

        synchronizeStrips(true, counts.bin);
        synchronizeStrips(false, counts.linear > 0 ? 1 : 0);
        this.updateHeight(1);
        if ($('.' + this.classLinear).children().length > 0) {
            lastStrip = $('.' + this.classLinear)
                .children()
                .last()[0].id;
        } else if ($('.' + this.classBinary).children().length > 0) {
            lastStrip = $('.' + this.classBinary)
                .children()
                .last()[0].id;
        }
        if (this.lastStrip != lastStrip) {
            clearChartObjects();
            this.lastStrip = lastStrip;
        }

        synchronizeChartObjects();
    },

    updateHeight: function (proceed, fakePageHeight) {
        if (this.chartLineCounts.bin == 0 && this.chartLineCounts.linear == 0) return;

        // when called without an parameter, it installs the event
        var self = this;
        if (!proceed) {
            $(window).resize(function () {
                self.updateHeight(1, fakePageHeight);
            });

            $('body').resize(function () {
                setTimeout(function () {
                    for (var key in self.charts) self.charts[key].resize();
                }, 1);
            });
            self.updateHeight(1, fakePageHeight);
            return;
        }

        // height is now calculated and set
        var h = fakePageHeight || window.innerHeight;
        this.heightDifference =
            $(this.el).offset().top + $(self.ui.footer.selector).outerHeight() + self.expectedMarginBottom;

        h = Math.max(h - this.heightDifference, this.minTotalHeight);

        $(this.el).css('height', h + 'px');

        var binHeight = this.chartLineCounts.linear == 0 ? h / this.chartLineCounts.bin : this.defaultBinHeight;

        var formatSize = function (x) {
            return '' + Math.floor(x) + 'px';
        };

        var sBinHeight = formatSize(binHeight);
        $('.' + this.classBinary)
            .children('div')
            .css('height', sBinHeight);

        if (this.chartLineCounts.linear == 0) {
            // the last strip has the range selector
            var rangeSelectorHeight = 30;
            var subtract = rangeSelectorHeight / (this.chartLineCounts.bin - 1);
            var binList = $('.' + this.classBinary).children('div');
            binHeight -= subtract;
            sBinHeight = formatSize(binHeight);
            binList.css('height', sBinHeight);
            binHeight += rangeSelectorHeight + subtract;
            sBinHeight = formatSize(binHeight);
            $(binList[binList.length - 1]).css('height', sBinHeight);
        }

        var linHeight = h - this.defaultBinHeight * this.chartLineCounts.bin;
        $('.' + this.classLinear)
            .children('div')
            .css('height', '' + linHeight + 'px');
    },

    setValueWindows: function (windows, key) {
        if (key === undefined) {
            for (var k in this.charts) {
                this.setValueWindows(windows, k);
            }
        } else {
            this.charts[key].updateOptions({
                axes: { y: { valueWindow: windows[key] } },
            });
        }
    },

    getValueWindows: function () {
        var valueWindows = {};
        for (var key in this.charts) {
            valueWindows[key] = $.extend(true, [], this.charts[key].axes_[0].valueWindow);
            if (valueWindows[key][0] === undefined) {
                if (this.charts[key].axes_[0].valueRange) {
                    valueWindows[key] = [
                        this.charts[key].axes_[0].valueRange[0],
                        this.charts[key].axes_[0].valueRange[1],
                    ];
                }
            }
        }

        return valueWindows;
    },

    getMaxDateWindow: function () {
        for (var key in this.charts) {
            var g = this.charts[key];
            var x1 = parseInt(moment(g.file_[0][0]).format('x'));
            var x2 = parseInt(moment(g.file_[g.file_.length - 1][0]).format('x'));
            return [x1, x2];
        }
    },

    getDateWindow: function () {
        var result = [];
        for (var key in this.charts) {
            var dw = this.charts[key].dateWindow_;
            if (dw && dw.length == 2) return dw;
        }

        return this.getMaxDateWindow();
    },

    // builds chart options
    updateOptions: function (showFrom, showTill, basicOnly, isReload, valueWindows, resetYZoom, resetXZoom) {
        var self = this;

        var getDateWindowDiff = function () {
            var dateWindow = self.getDateWindow();
            var maxDateWindow = self.getMaxDateWindow();

            var diff = Math.max(Math.abs(dateWindow[0] - maxDateWindow[0]), Math.abs(dateWindow[1] - maxDateWindow[1]));
            return diff;
        };

        var getRelDateWindowDiff = function () {
            var dateWindow = self.getDateWindow();
            var maxDateWindow = self.getMaxDateWindow();

            var diff = Math.max(Math.abs(dateWindow[0] - maxDateWindow[0]), Math.abs(dateWindow[1] - maxDateWindow[1]));
            return diff / (maxDateWindow[1] - maxDateWindow[0]);
        };

        var isKeepZoom = function () {
            var rel = getRelDateWindowDiff();
            return rel >= 0.2;
        };

        var lastChart = undefined;
        for (var key in this.charts) {
            lastChart = key;
        }

        var binaryIdx = 0;
        var valueWindows = valueWindows || this.getValueWindows();
        var dateWindow = [showFrom, showTill];

        if (isReload && isKeepZoom() && !resetXZoom) {
            dateWindow = this.getDateWindow();
        } else {
            //find out the first row with actual data
            if (!resetXZoom) {
                var firstRow = this.data.getFirstTime();
                if (firstRow) dateWindow[0] = firstRow;
            }
        }

        this.lastChartID = lastChart;
        this.chartData = {};

        if (!basicOnly) this.chartAxesSettings = {};

        for (var key in this.charts) {
            var isBinary = $('#' + key)
                .parent()
                .hasClass('chart-bin');
            var isLast = lastChart == key;
            if (!this.charts[key].trovisContext) this.charts[key].trovisContext = {};

            // here we decide which series belong to this chart
            var composedData = this.data.compose(isBinary, isBinary ? binaryIdx : 0, showFrom, showTill);
            if (isLast) this.chartAxesSettings[key] = this.data.normalize(composedData, this.chartAxesSettings[key]);
            else composedData.normalized = composedData.data;

            this.chartData[key] = composedData;

            if (isBinary) {
                binaryIdx++;
            }
        }

        var maxLabelWidth = this.calculateMaxLabelWidth();
        binaryIdx = 0;

        for (var key in this.charts) {
            var isBinary = $('#' + key)
                .parent()
                .hasClass('chart-bin');
            var isLast = lastChart == key;

            this.charts[key].trovisContext.isBinary = isBinary;
            this.charts[key].trovisContext.isLast = isLast;

            var composedData = this.chartData[key];

            this.chartAxes[key] = Misc.selectWhere(composedData.series, undefined, 'actualAxis', true);
            this.switchAxis(key, 0, composedData.series);

            var options = {
                dateWindow: dateWindow,
            };

            var kMin = isBinary ? 0.1 : 0.15;
            var kMax = isBinary ? 0.1 : 0.1;

            if (!basicOnly) {
                setTimeout(function () {
                    self.charts[key].height_ = (self.charts[key].height_ || 0) - 1;
                    self.charts[key].resize();
                }, 100);

                var newValueRange = [-0.1, 1.2];
                if (isLast) {
                    newValueRange = [composedData.series[0].actualMin, composedData.series[0].actualMax];
                }

                if (isBinary) {
                    newValueRange = this.binaryValueRange;
                }

                var extraOptions = {
                    labels: composedData.labels,
                    colors: composedData.colors,
                    seriesInfo: composedData.series,
                    isLast: isLast,
                    strokeWidth: 1,
                    panEdgeFraction: 0.0001,
                    legend: 'always',
                    showRangeSelector: isLast,
                    valueRange: newValueRange,
                    interactionModel: Dygraph.Interaction.defaultModel,
                    axes: {
                        x: {
                            drawAxis: isLast,
                        },
                    },
                    drawCallback: function (me, initial) {
                        self.trigger('charts:draw:after');
                    },

                    drawHighlightPointCallback: function (g, seriesName, ctx, cx, cy, color, radius, idx) {
                        var labels = g.getLabels();
                        var tmp = g.getOption('interpolatedData');
                        var k = 1;
                        var seriesIdx = labels.indexOf(seriesName) - 1;

                        if (tmp && (tmp[idx] & (1 << seriesIdx)) > 0) k = 2;

                        ctx.beginPath();
                        ctx.strokeStyle = color;
                        ctx.arc(cx, cy, radius / k, 0, 2 * Math.PI, false);
                        ctx.fill();
                        ctx.stroke();
                    },

                    highlightCallback: function (event, x, pts, row, seriesName) {
                        for (var key in self.charts) {
                            var c = self.charts[key];
                            if (c.setSelectorLine && !c.isTouchMoving) {
                                c.setSelectorLine(pts);
                            }
                        }
                    },
                };

                options = $.extend({}, true, options, extraOptions);
            }

            if (valueWindows[key] && valueWindows[key].length > 0) {
                var w = valueWindows[key];
                if (resetYZoom && !isBinary) {
                    w = [composedData.series[0].actualMin, composedData.series[0].actualMax];
                }
                options.axes = {
                    y: {
                        valueWindow: w,
                    },
                };
            }

            if (isBinary) options.valueRange = this.binaryValueRange;
            else options.valueRange = [composedData.series[0].actualMin, composedData.series[0].actualMax];

            options.file = composedData.normalized;
            options.originalData = composedData.data;
            options.interpolatedData = composedData.interpolated;
            options.timeshift = this.data.timeshift;
            self.axisSeriesUnitCount = undefined;
            self.axisTicks = {};

            if (!basicOnly) {
                options.series = {};
                for (var i = 1; i < composedData.labels.length; i++) {
                    var sKey = composedData.labels[i];
                    options.series[sKey] = {};

                    options.series[sKey].plotter = self.lineChartPlotter;
                    var chartType =
                        composedData.series[i - 1].displaySettings &&
                        composedData.series[i - 1].displaySettings.chartType;
                    if (chartType == 1) {
                        options.series[sKey].plotter = self.barChartPlotter;
                    }
                    if (chartType == 2) {
                        options.series[sKey].plotter = self.lineAggChartPlotter;
                    }
                    options.series[sKey].axis = composedData.series[i - 1].actualSide == 1 ? 'y2' : 'y';
                }

                options.axes = {
                    x: {
                        drawAxis: isLast,
                        axisLabelFormatter: function (d, gran, opts) {
                            d = new Date(d);
                            var hrs = d.getHours();
                            var mins = d.getMinutes();
                            var secs = d.getSeconds();

                            var getTimeStr = function () {
                                if (hrs == 0 && mins == 0 && secs == 0) {
                                    return '' + d.getDate() + ' ' + Consts.MonthNamesShort[d.getMonth()];
                                }
                                return moment(d).format('HH:mm');
                            };

                            var result = getTimeStr();
                            // one more exception - only minutes are displayed at the datum. if there are any seconds, the date won't be shown
                            if (new Date(d).getTime() % 60000 != 0) return '';

                            return self.checkAxisTick(result, new Date(d).getTime(), 'x');
                        },
                        valueFormatter: function (ms) {
                            moment.locale(i18n.language, { weekdaysMin: Consts.DaysOfWeek });
                            return moment(ms).format('YYYY/MM/DD (dd) HH:mm');
                        },
                    },
                    y: {
                        // special case: all series use the same unit
                        axisLabelWidth: maxLabelWidth,
                        axisLabelFormatter: function (v, gran, opts) {
                            return self.checkAxisTick(self.getChartTickValue(v, key, this), v, 'y');
                        },
                    },
                };
            }

            options.annotateEvents = [];
            if (self.showEvents) {
                options.annotateEventsShowIcons = isLast;
                options.annotateEvents = _.sortBy(
                    _.filter(
                        _.map(this.data.eventlog, function (a, i) {
                            var tmp = self.buildEventAnnotation(a);
                            if (tmp) {
                                tmp.id = i + 1;
                                return tmp;
                            }
                        }),
                        function (a) {
                            return a;
                        }
                    ),
                    function (a) {
                        return a.x;
                    }
                );
            }

            this.charts[key].updateOptions(options);
            if (isBinary) {
                binaryIdx++;
            }
        }

        if (!basicOnly) {
            var graphs = [];
            for (var key in this.charts) {
                graphs.push(this.charts[key]);
            }
            if (graphs.length > 1) {
                var sync = Dygraph.synchronize(graphs, { zoom: true, selection: true });
            }
        }

        // trigger showing the legend
        if (!basicOnly && lastChart && this.data.rawData && this.data.rawData.length > 0) {
            this.charts[lastChart].cascadeEvents_('select', {});
        }
    },

    checkAxisTick: function (text, value, axis) {
        var checkText = text;
        // exception: include date part when it's the x-axis
        if (axis == 'x') {
            checkText = moment(value).format('YYYY/MM/DD') + ' ' + text;
        }

        this.axisTicks = this.axisTicks || {};
        this.axisTicks[axis] = this.axisTicks[axis] || {};
        if (this.axisTicks[axis][checkText] && this.axisTicks[axis][checkText] != value) return '';
        this.axisTicks[axis][checkText] = value;
        return text;
    },

    getChartTickValue: function (v, key, g) {
        var self = this;
        if (!g.user_attrs_.seriesInfo) return v;
        if (g.user_attrs_.seriesInfo.length == 1 && Misc.getValueLikeCoil(g.user_attrs_.seriesInfo[0].type)) {
            if (v == 0 || v == 1) return v;
            return Misc.roundValue(v);
            // return Math.round(v, 1);
        }
        if (this.selectedAxis[key] === undefined) {
            this.selectedAxis[key] = 0;
        }

        var composedData = this.chartData[key];
        var tmp = Misc.selectWhere(composedData.series, function (a) {
            return a.actualAxis == self.selectedAxis[key];
        });
        var nv = v;
        var selected = tmp[0];

        nv = (v - selected.axisCalc.q) / selected.axisCalc.k;
        nv = Misc.roundValue(nv);

        var preferredUnit = Misc.getValueDisplayInfos(
            selected.actualMax || selected.actualMin,
            selected.type,
            selected.format,
            selected.unit,
            selected.display_unit,
            selected.is_unit_fixed
        ).unit;

        var valueData = Misc.getValueDisplayInfos(
            nv,
            selected.type,
            selected.format,
            selected.unit,
            preferredUnit,
            true
        );
        return valueData.value + ' ' + valueData.unit;
    },

    calculateMaxLabelWidth: function () {
        var numbers = [];
        // collect axis values
        _.each(this.chartData, function (composedData) {
            _.each(composedData.series, function (serie) {
                var range = Misc.roundValue((serie.actualMax - serie.actualMin) / 11);
                var from = serie.actualMax - range / 2;
                var till = serie.actualMin + range / 2;
                for (var x = from; x >= till; x -= range) {
                    numbers.push({
                        value: Misc.roundValue(x),
                        serie: serie,
                    });
                }
            });
        });

        // get the max len
        var maxLen = _.max(
            Misc.selectWhere(numbers, undefined, function (x) {
                var valueInfo = Misc.getValueDisplayInfos(
                    x.value,
                    x.serie.type,
                    x.serie.format,
                    x.serie.unit,
                    x.serie.display_unit,
                    x.serie.is_unit_fixed
                );
                var value = valueInfo.value + ' ' + valueInfo.unit;
                return Misc.getStringWidth(value);
            })
        );

        return Math.max(maxLen + this.labelPadding, this.labelMinWidth);
    },

    switchAxis: function (key, step, seriesInfo) {
        var self = this;
        if (this.selectedAxis[key] === undefined) this.selectedAxis[key] = 0;
        this.selectedAxis[key] += step;
        if (this.selectedAxis[key] < 0) this.selectedAxis[key] = this.chartAxes[key].length - 1;
        this.selectedAxis[key] = this.selectedAxis[key] % this.chartAxes[key].length;

        if (seriesInfo === undefined) {
            var g = this.charts[key];
            seriesInfo = g.user_attrs_.seriesInfo;
        }
        _.each(seriesInfo, function (si) {
            si.selected = si.actualAxis == self.selectedAxis[key];
        });
        var g = this.charts[key];
        g.cascadeEvents_('select', {
            selectedRow: g.lastRow_,
            selectedX: g.lastx_,
            selectedPoints: g.selPoints_,
        });
    },
});

module.exports = ChartView;
